import script from "./MyAccountDocuments.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAccountDocuments.vue?vue&type=script&setup=true&lang=js"

import "./MyAccountDocuments.vue?vue&type=style&index=0&id=5763e8cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5763e8cc"]])

export default __exports__